import React, { useState, useEffect } from "react";
import { Col, Form, Row, Image, Button } from "react-bootstrap";
import { useHistory } from "react-router";
import { TextField, FormControl, Select } from "@material-ui/core";
import Switch from "react-switch";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { useFormik } from "formik";
import * as yup from "yup";
import moment from "moment";
import InputNumberFunc from "../../../../../function/InputNumberFunc";
import { InputCharacterCheck } from "../../../../../function/InputCharNumCheckFunc";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import Alert from "react-s-alert";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../store/actions/errorActions";
import { AddDinerValidation } from "../../../../../store/validation/allValidationFile/seatingDashboard/AddDinerValidation";
import {
  add_rsvp_events,
  rsvp_edit_perticular_event_request,
  //   get_diner_reservation,
  //   get_pending_diner,
  //   get_reservation_diner,
} from "../../../../../store/actions/RsvpEventDashboard/RsvpEventDashboardAction";
import isEmpty from "../../../../../store/validation/is-Empty";
import store from "../../../../../store/store";
import { SET_DINER_DETAILS } from "../../../../../store/types";
import { ReusableOnboardingMapButton } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import Media from "react-media";
import { amApi } from "../../../../../api/apiHelper";
import { errorAlert } from "../../../../../function/alert";

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const emailRegExp =
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

const validationSchema = yup.object({
  mobile_number: yup
    .string()
    .required("Phone number is required")
    .matches(phoneRegExp, "Phone number is not valid")
    .min(10, "too short")
    .max(10, "too long"),
  // occasion: yup
  //   .string()
  //   .required("Occasion is required")
  //   .min(1, "Minimum 1 Character")
  //   .max(512, "Maximum 512 Character"),
  userName: yup
    .string()
    .required("Name is required")
    .min(1, "Minimum 1 Character")
    .max(64, "Maximum 64 Character"),
  email: yup.string().matches(emailRegExp, "Email is not valid"),
});

const AddRsvpEvent = (props) => {
  const history = useHistory();
  const [allSeatingArea, setAllSeatingArea] = useState([]);
  //state
  const [state, setState] = useState({
    code: "",
    adult: 0,
    kids: 0,
    handicap: 0,
    highchair: 0,
    allDinerDetails: [],
    onBoardingHighChair: false,
    onBoardingHandicap: false,
    onBoardingTableNumber: false,
    onBoardingRoomNumber: false,
    onBoardingkidsallowed: false,
    autoAcceptPaxLimit: 0,
    allSeatingArea: [],
    wait_time: "",
    sameNumberError: "",
    loader: false,
    hasSetDiner: false,
    rsvpToggle: false,
    deviceToken: "",
  });

  const handleChangeCode = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
  };
  const [checkedBox, setCheckedBox] = useState(false);
  const handleChangeSwitch = (e) =>
    setCheckedBox({ checkedBox: !checkedBox.checkedBox });

  /***************************
   * @DESC on Button Handler
   ***************************/
  // const onButtonClick = (e, type) => {
  //   e.preventDefault();
  //   setState({
  //     ...state,
  //     seating_preference: type,
  //   });
  // };

  /***************************************
   * Start Adult kids highchair handicap
   **************************************/
  const IncrementKidsItem = (e) => {
    e.preventDefault();
    let totalPeople = state.adult + state.kids;
    let maxRsvpPeople = props.getSingleEventInfo?.max_people_RSVP;
    if (props.getSingleEventInfo?.isKidsAllowed) {
      if (totalPeople >= maxRsvpPeople) {
        Alert.error(
          `<h4>You can't add more than ${maxRsvpPeople} people</h4>`,
          {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          }
        );
      } else {
        if (state.adult === 0) {
          if (state.kids < 100) {
            setState({
              ...state,
              kids: state.kids + 1,
              adult: state.adult + 1,
            });
          } else {
            setState({
              ...state,
              kids: state.kids + 1,
            });
          }
        } else {
          setState({
            ...state,
            kids: state.kids + 1,
          });
        }
      }
    } else {
      Alert.error(`<h4>Please enable kids Allowed in this event</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };
  const IncrementAdultItem = (e) => {
    e.preventDefault();
    let totalPeople = state.adult + state.kids;
    let maxRsvpPeople = props.getSingleEventInfo?.max_people_RSVP;
    if (totalPeople >= maxRsvpPeople) {
      Alert.error(`<h4>You can't add more than ${maxRsvpPeople} people</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      if (state.adult < 100) {
        setState({
          ...state,
          adult: state.adult + 1,
        });
      } else {
        return null;
      }
    }
  };
  const IncrementhandicapItem = (e) => {
    e.preventDefault();
    let totalPeople = state.adult + state.kids;
    let totalHighChairHandicapped = state.highchair + state.handicap;
    if (totalPeople === 0) {
      Alert.error(`<h4>Please add at least one person</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      if (totalPeople > totalHighChairHandicapped) {
        if (state.handicap < 100) {
          setState({
            ...state,
            handicap: state.handicap + 1,
          });
        } else {
          return null;
        }
      } else {
        Alert.error(`<h4>You can't add more than adult and kids people</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    }
  };
  const IncrementhighchairItem = (e) => {
    e.preventDefault();
    let totalPeople = state.adult + state.kids;
    let totalHighChairHandicapped = state.highchair + state.handicap;
    if (totalPeople === 0) {
      Alert.error(`<h4>Please add at least one person</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      if (totalPeople > totalHighChairHandicapped) {
        if (state.highchair < 100) {
          setState({
            ...state,
            highchair: state.highchair + 1,
          });
        } else {
          return null;
        }
      } else {
        Alert.error(`<h4>You can't add more than adult and kids people</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    }
  };

  const DecreaseKidsItem = (e) => {
    e.preventDefault();
    if (state.kids > 0) {
      setState({
        ...state,
        kids: state.kids - 1,
      });
    } else {
      return null;
    }
  };

  const DecreaseAdultItem = (e) => {
    e.preventDefault();
    if (state.adult > 0) {
      setState({
        ...state,
        adult: state.adult - 1,
      });
    } else {
      return null;
    }
  };

  const DecreaseHandicapItem = (e) => {
    e.preventDefault();

    if (state.handicap > 0) {
      setState({
        ...state,
        handicap: state.handicap - 1,
      });
    } else {
      return null;
    }
  };
  const DecreaseHighchairItem = (e) => {
    e.preventDefault();
    if (state.highchair > 0) {
      setState({
        ...state,
        highchair: state.highchair - 1,
      });
    } else {
      return null;
    }
  };
  /***************************************
   * End Adult kids highchair handicap
   **************************************/

  const onChange = (e) => {
    let data = e.target.value.split(" ");
    let newarray1 = [];
    for (let x = 0; x < data.length; x++) {
      newarray1.push(data[x].charAt(0).toUpperCase() + data[x].slice(1));
    }
    let newData = newarray1.join(" ");
    setState({
      ...state,
      [e.target.name]: newData,
    });
  };

  /***************************
   * @DESC on Button Handler
   ***************************/
  const onButtonClick = (type) => {
    formik.setFieldValue("seating_preference", type);
  };

  useEffect(() => {
    // subscriptionData;
    // rsvp : value
    // kids_allowed: value,
    // booking_enabled: value,
    // highchair(pin):false
    // handicap(pin):false
    // room_number_on_request(pin):false
    // user_template(pin):false
    if (!isEmpty(props.eventInfo) && !state.hasSetDiner) {
      setState({
        ...state,
        code: !isEmpty(props.auth.user.VendorUser.country_code)
          ? props.auth.user.VendorUser.country_code
          : "",
        onBoardingHighChair: !isEmpty(props.eventInfo.highchair)
          ? props.eventInfo.highchair
          : "",
        onBoardingHandicap: !isEmpty(props.eventInfo.handicap_access)
          ? props.eventInfo.handicap_access
          : "",
        onBoardingkidsallowed: !isEmpty(props.eventInfo.isKidsAllowed)
          ? props.eventInfo.isKidsAllowed
          : false,
        // onBoardingTableNumber: !isEmpty(props.onboarding.table_management)
        //   ? props.onboarding.table_management
        //   : "",
        onBoardingRoomNumber: !isEmpty(props.eventInfo.room_on_seating_rq)
          ? props.eventInfo.room_on_seating_rq
          : false,
        allSeatingArea: !isEmpty(props.seatingArea) ? props.seatingArea : [],
        // wait_time: !isEmpty(props.onboarding.seatingWaitingTime)
        //   ? props.onboarding.seatingWaitingTime
        //   : "",
        autoAcceptPaxLimit: !isEmpty(props.eventInfo.auto_accept_pax)
          ? props.eventInfo.auto_accept_pax
          : "",
        hasSetDiner: true,
      });
    }
  }, [props.eventInfo]);

  // useEffect(() => {
  //   const seating =
  //     props.allSeatingAreas &&
  //     props.allSeatingAreas?.filter((seat) =>
  //       props.allSeatingAreas.includes(seat?._id)
  //     );
  //   setAllSeatingArea(seating);
  // }, [props.seatingArea, props.allSeatingAreas]);

  useEffect(() => {
    if (props?.subscriptionDetails) {
      if (props?.subscriptionDetails?.casual_dining) {
        const seating = props?.allSeatingAreas?.filter((seat) =>
          props?.subscriptionDetails?.casual_dining_status?.seating?.general_seating?.seating_areas.includes(
            seat?._id
          )
        );
        setAllSeatingArea(seating);
      } else if (props?.subscriptionDetails?.multi_service_business) {
        const seating = props?.allSeatingAreas?.filter((seat) =>
          props?.subscriptionDetails?.multi_service_business_status?.seating?.general_seating?.seating_areas.includes(
            seat?._id
          )
        );
        setAllSeatingArea(seating);
      }
    }
  }, [props.subscriptionDetails, props.allSeatingAreas]);

  const formik = useFormik({
    initialValues: {
      id: "",
      vendor_id: "",
      kids: 0,
      adult: 0,
      handicap: 0,
      highchair: 0,
      room_number: "",
      table_number: "",
      occasion: "",
      seating_preference: "",
      wait_time: "",
      service_type: "",
      pointOfEntry: "",
      userName: "",
      email: "",
      user_details: {
        country_code: "",
        mobile_number: "",
        name: "",
        email: "",
      },
      wait_time: "",
      service_type: "",
      pointOfEntry: "",
      payment_status: "",
      event_status: "PENDING",
    },
    validationSchema,

    onSubmit: (values) => {
      var formData = {};
      var editData = {};
      var token = props.auth.user.accessToken;
      if (props?.editAction) {
        editData.event_id = props.eventInfo._id;
        editData.vendor_id = props.auth.user.VendorUser._id;
        editData.restaurant_id = props.eventInfo.restaurant_id;
        editData.kids_count = state.kids;
        editData.adult_count = state.adult;
        editData.handicap_chair = state.handicap;
        editData.high_chair = state.highchair;
        editData.occasion = values.occasion;
        editData.seating_preference = values.seating_preference;
        editData.room_number = values.room_number.toString();
        editData.table_number = [values.table_number.toString()];
        editData.user_details = {
          country_code: state.code,
          deviceToken: state.deviceToken,
          mobile_number: values.mobile_number.toString(),
          name: values.userName,
          email: values.email,
        };
      } else {
        formData.event_id = props.eventInfo._id;
        formData.vendor_id = props.auth.user.VendorUser._id;
        formData.restaurant_id = props.eventInfo.restaurant_id;
        formData.kids_count = state.kids;
        formData.adult_count = state.adult;
        formData.handicap_chair = state.handicap;
        formData.high_chair = state.highchair;
        formData.room_number = values.room_number.toString();
        formData.seat_number = [values.table_number.toString()];
        formData.occasion = values.occasion;
        formData.seating_preference = values.seating_preference;
        // formData.wait_time = parseInt(state.wait_time.split("-")[1]);
        formData.event_type = "RSVP";
        formData.event_status = values.event_status;
        formData.service_type = "SEATING";
        formData.pointOfEntry = "VENDOR";
        formData.user_details = {
          country_code: state.code,
          mobile_number: values.mobile_number.toString(),
          name: values.userName,
          email: values.email,
        };
        formData.payment_status = 0;
      }

      // console.log(formData);
      // console.log(props.eventInfo);
      let totalPeople = state.adult + state.kids;
      let minRsvpPeople = props.getSingleEventInfo?.min_people_RSVP;
      let maxRsvpPeople = props.getSingleEventInfo?.max_people_RSVP;
      if (totalPeople < minRsvpPeople) {
        Alert.error(
          `<h4>You can add atleast minimum ${minRsvpPeople} people for RSVP</h4>`,
          {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          }
        );
      } else if (totalPeople > maxRsvpPeople) {
        Alert.error(
          `<h4>You can't add more than ${maxRsvpPeople} people for RSVP</h4>`,
          {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          }
        );
      } else {
        if (props?.editAction) {
          props.rsvp_edit_perticular_event_request(
            editData,
            props?.editGeustUserData._id,
            token,
            onEditSuccess
          );
        } else {
          props.add_rsvp_events(formData, token, onCallBackFunc);
        }
      }
    },
  });

  const onCallBackFunc = (e) => {
    Alert.success("<h4>Event Added Successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    history.push({
      pathname: `/offline-events-details/${
        props.eventInfo && props.eventInfo._id
      }`,
      state: {
        offlineEventInformation: props.eventInfo && props.eventInfo._id,
      },
    });
  };
  const onEditSuccess = (e) => {
    Alert.success("<h4>Event Information Update Successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    history.push({
      pathname: `/offline-events-details/${
        props?.eventInfo && props?.eventInfo?._id
      }`,
      state: {
        offlineEventInformation: props?.eventInfo && props?.eventInfo?._id,
      },
    });
  };

  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik.handleSubmit();
  };

  const adultError = () => {
    let kidsAdultsPeople = state.kids + state.adult;
    let highChairHandicapPeople = state.handicap + state.highchair;
    if (!props.eventSessionSettings?.RSVP) {
      Alert.error(
        "<h4>You can't placed an RSVP request because RSVP closed in session settings</h4>",
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        }
      );
    } else if (props.getSingleEventInfo?.rsvp_booking_closed) {
      Alert.error(
        "<h4>You can't placed an RSVP request because RSVP booking closed now</h4>",
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        }
      );
    } else {
      if (state.adult === 0) {
        Alert.error("<h4>Please Enter Party Size</h4>", {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      } else if (highChairHandicapPeople > kidsAdultsPeople) {
        Alert.error("<h4>You can't add more than adult and kids people</h4>", {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      } else {
        onClickSave();
      }
    }
  };

  useEffect(() => {
    console.log("props?.editGeustUserData", props?.editGeustUserData);
    if (!isEmpty(props?.editGeustUserData)) {
      // formik.setFieldValue(
      //   "user_details.country_code",
      //   props?.editGeustUserData?.user_details?.country_code
      // );
      formik.setFieldValue(
        "mobile_number",
        props?.editGeustUserData?.user_details?.mobile_number
      );
      formik.setFieldValue(
        "userName",
        props?.editGeustUserData?.user_details?.name
      );
      formik.setFieldValue("email", props?.editGeustUserData?.user_id?.email);

      formik.setFieldValue(
        "room_number",
        props?.editGeustUserData?.room_number
      );
      formik.setFieldValue(
        "seat_number",
        props?.editGeustUserData?.seat_number
      );
      formik.setFieldValue("occasion", props?.editGeustUserData?.occasion);
      formik.setFieldValue(
        "seating_preference",
        props?.editGeustUserData?.seating_preference.toString()
      );
      formik.setFieldValue(
        "user_details.email",
        props?.editGeustUserData?.email
      );
      formik.setFieldValue(
        "event_status",
        props?.editGeustUserData?.event_status
      );
      setState({
        ...state,
        code: props?.editGeustUserData?.user_details?.country_code,
        adult: props?.editGeustUserData?.adult_count,
        kids: props?.editGeustUserData?.kids_count,
        handicap: props?.editGeustUserData?.handicap_chair,
        highchair: props?.editGeustUserData?.high_chair,
        wait_time: props?.editGeustUserData?.wait_time,
        deviceToken:
          props?.editGeustUserData?.user_details?.deviceToken !== undefined &&
          props?.editGeustUserData?.user_details?.deviceToken !== null
            ? props?.editGeustUserData?.user_details?.deviceToken
            : "",
      });
    }
  }, [props?.editGeustUserData]);

  useEffect(() => {
    // formik.setFieldValue("mobile_number", "");
  }, []);
  // for set focus
  useEffect(() => {
    if (formik.errors && formik.errors.mobile_number) {
      let mobileNumberElement = document.getElementById("mobile_number");
      mobileNumberElement.focus();
    } else if (formik.errors && formik.errors.userName) {
      let userNameElement = document.getElementById("userName");
      userNameElement.focus();
    }
    //  else if (formik.errors && formik.errors.occasion) {
    //   let occasionElement = document.getElementById("occasion");
    //   occasionElement.focus();
    // }
  }, [count]);

  const handleBlur = (e) => {
    store.dispatch({
      type: SET_DINER_DETAILS,
      payload: {
        mobile_number: formik.values.mobile_number,
        dinerName: formik.values.userName,
      },
    });
  };

  const [userData, setUserData] = useState("");
  const handleNumber = async () => {
    let params = {
      mobile_number:
        formik.values?.mobile_number ||
        formik.values?.user_details?.mobile_number,
      country_code: state?.code || formik.values?.user_details?.country_code,
    };
    let mobiReg = /^[6-9]\d{9}$/;
    if (mobiReg.test(params.mobile_number)) {
      let userRes = await amApi.get("/user-check", { params: params });
      if (userRes.status === 200 && !isEmpty(userRes.data)) {
        setUserData(userRes.data);
        formik.setFieldValue(
          "userName",
          userRes.data?.first_name + " " + userRes.data?.last_name
        );
        formik.setFieldValue("email", userRes.data?.email);
      } else {
        setUserData({ mobile_number: params.mobile_number });
        formik.setFieldValue("userName", "");
        formik.setFieldValue("email", "");
      }
    }
    //  else {
    //   errorAlert("Invalid Mobile Number");
    // }
  };

  // useEffect(() => {
  //   if (userData) {
  //     setTimeout(() => {
  //       formik.setFieldValue(
  //         "userName",
  //         userData?.first_name + " " + userData?.last_name
  //       );
  //     }, 2000);
  //   }
  // }, [userData]);

  const onChangeHighChairHandiCap = () => {
    setState({ ...state, rsvpToggle: !state.rsvpToggle });
  };

  const totalAdultKids = state.kids + state.adult;
  return (
    <React.Fragment>
      {props.getSingleEventInfo?.rsvp_booking_closed ? (
        <div>
          <p className="f13-500" style={{ color: "#EE3A23" }}>
            RSVP Booking Closed Now
          </p>
        </div>
      ) : null}
      <Form className="py-4">
        <Row className="px-2">
          <Col md={12} lg={10} xl={8}>
            <Row>
              <Col md={6}>
                <Row>
                  <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                    <Form.Group
                      // className="reusableInputComponent-main mb-0"
                      controlId={"code"}
                    >
                      <div className="input-phone-country-code-reusable w-100">
                        <select
                          name="code"
                          value={state.code}
                          onChange={onChange}
                          className="w-100"
                        >
                          <option value={state.code}>{state.code}</option>
                          {getCountries().map((country) => (
                            <option
                              key={country}
                              value={"+" + getCountryCallingCode(country)}
                            >
                              {en[country]} (+{getCountryCallingCode(country)})
                            </option>
                          ))}
                        </select>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xs={8}>
                    <Form.Group>
                      <TextField
                        id="mobile_number"
                        label="Phone Number"
                        type="number"
                        variant="outlined"
                        className={`w-100 ${
                          formik.errors.mobile_number &&
                          formik.touched.mobile_number
                            ? "enError"
                            : ""
                        }`}
                        onInput={(e) => {
                          e.target.value = Math.max(0, parseInt(e.target.value))
                            .toString()
                            .slice(0, 10);
                        }}
                        name="mobile_number"
                        onChange={formik.handleChange}
                        value={formik.values.mobile_number}
                        onBlur={(formik.handleBlur, handleNumber)}
                      />
                      {formik.errors.mobile_number &&
                      formik.touched.mobile_number ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.mobile_number}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <TextField
                    id="userName"
                    label="Name"
                    type="text"
                    variant="outlined"
                    className={`w-100 ${
                      formik.errors.userName && formik.touched.userName
                        ? "enError"
                        : ""
                    }`}
                    inputProps={{
                      maxLength: 64,
                    }}
                    name="userName"
                    onChange={formik.handleChange}
                    value={formik.values.userName}
                    onBlur={formik.handleBlur}
                    // isInvalid={formik.errors.name && formik.touched.name}
                  />
                  {formik.errors.userName && formik.touched.userName ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.userName}
                    </div>
                  ) : null}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <TextField
                    id="email"
                    label="Email"
                    type="text"
                    variant="outlined"
                    className={`w-100 ${
                      formik.errors.email && formik.touched.email
                        ? "enError"
                        : ""
                    }`}
                    inputProps={{
                      maxLength: 64,
                    }}
                    name="email"
                    onChange={formik.handleChange}
                    value={formik.values.email}
                    onBlur={formik.handleBlur}
                    // isInvalid={formik.errors.name && formik.touched.name}
                  />
                  {formik.errors.email && formik.touched.email ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.email}
                    </div>
                  ) : null}
                </Form.Group>
              </Col>
              <Col md={12} lg={8}>
                <div className="f16-500 py-3">Party Size</div>
                <div className="col-8 f10-400 text-gray d-flex pl-0 mb-4">
                  <i className="fa fa-info-circle mr-2" aria-hidden="true"></i>
                  The Kids ranging below 6 years will be kept under the kids
                  Category
                </div>
                <div className="d-flex enPartySize">
                  {state.onBoardingkidsallowed ? (
                    <div className="d-flex pr-3 pb-3">
                      <div className="enKidsIcon mr-2">
                        <Image
                          src={require("../../../../../assets/images/ActionImages/children.png")}
                          alt="View"
                          title="View"
                          width="9px"
                        />
                      </div>
                      <div className="pl-md-2 enPartyPersonEdit">
                        <div className="f14-500 pb-2">Kids</div>
                        <div className="d-flex align-items-center">
                          <Button
                            variant="link"
                            className="p-0"
                            onClick={DecreaseKidsItem}
                          >
                            <Image
                              src={require("../../../../../assets/images/UserManagement/minus.svg")}
                              alt="Remove"
                              title="Remove"
                              fluid
                            />
                          </Button>
                          <input
                            placeholder="00"
                            className="enInputValueOnly f12-700"
                            value={state.kids}
                            onChange={() => {}}
                          />
                          <Button
                            variant="link"
                            className="p-0"
                            onClick={IncrementKidsItem}
                          >
                            <Image
                              src={require("../../../../../assets/images/UserManagement/plus.svg")}
                              alt="Add"
                              title="Add"
                              fluid
                            />
                          </Button>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <div className="d-flex border-left pl-3 pb-3">
                    <div className="enKidsIcon mr-2">
                      <Image
                        src={require("../../../../../assets/images/ActionImages/employees.png")}
                        alt="View"
                        title="View"
                        width="9px"
                      />
                    </div>
                    <div className="pl-md-2 enPartyPersonEdit">
                      <div className="f14-500 pb-2">Adult</div>
                      <div className="d-flex align-items-center">
                        <Button
                          variant="link"
                          className="p-0"
                          onClick={DecreaseAdultItem}
                        >
                          <Image
                            src={require("../../../../../assets/images/UserManagement/minus.svg")}
                            alt="Remove"
                            title="Remove"
                            fluid
                          />
                        </Button>
                        <input
                          placeholder="00"
                          className="enInputValueOnly f12-700"
                          value={state.adult}
                          onChange={() => {}}
                        />
                        <Button
                          variant="link"
                          className="p-0"
                          onClick={IncrementAdultItem}
                        >
                          <Image
                            src={require("../../../../../assets/images/UserManagement/plus.svg")}
                            alt="Add"
                            title="Add"
                            fluid
                          />
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                {props.getSingleEventInfo?.handicap_access === true ||
                props.getSingleEventInfo?.highchair === true ? (
                  <React.Fragment>
                    <div className="d-flex flex-wrap  align-items-center pb-4">
                      <div className="f16-500">
                        Need Handicap access or a Highchair?
                      </div>
                      <div className="d-flex align-items-center py-4 pl-md-4">
                        <div className="f16-500 mr-2">No</div>
                        <Switch
                          onChange={onChangeHighChairHandiCap}
                          checked={state.rsvpToggle}
                          offColor="#EEEEEE"
                          onColor="#EEEEEE"
                          offHandleColor="#212121"
                          onHandleColor="#59F832"
                          handleDiameter={24}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={15}
                          width={41}
                          boxShadow="-2px 0px 5px #0000003B"
                          activeBoxShadow="-2px 0px 5px #0000003B"
                          id="material-switch"
                          // disabled={true}
                        />
                        <div className="f16-500 ml-2">Yes</div>
                      </div>
                    </div>
                    {state.rsvpToggle ? (
                      <React.Fragment>
                        <div className="d-flex enPartySize pb-4">
                          {state.onBoardingHandicap === true ? (
                            <div className="d-flex pr-3 pb-3">
                              <div className="enKidsIcon mr-2">
                                <Image
                                  src={require("../../../../../assets/images/ActionImages/wheelchair.png")}
                                  alt="View"
                                  title="View"
                                  className="custom"
                                />
                              </div>
                              <div className="pl-md-2 enPartyPersonEdit">
                                <div className="f14-500 pb-2">Handicap</div>
                                <div className="d-flex align-items-center">
                                  <Button
                                    variant="link"
                                    className="p-0"
                                    onClick={DecreaseHandicapItem}
                                  >
                                    <Image
                                      src={require("../../../../../assets/images/UserManagement/minus.svg")}
                                      alt="Remove"
                                      title="Remove"
                                      fluid
                                    />
                                  </Button>
                                  <input
                                    placeholder="00"
                                    className="enInputValueOnly f12-700"
                                    value={state.handicap}
                                    onChange={() => {}}
                                  />
                                  <Button
                                    variant="link"
                                    className="p-0"
                                    onClick={IncrementhandicapItem}
                                  >
                                    <Image
                                      src={require("../../../../../assets/images/UserManagement/plus.svg")}
                                      alt="Add"
                                      title="Add"
                                      fluid
                                    />
                                  </Button>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {state.onBoardingHighChair === true ? (
                            <div className="d-flex border-left pl-3 pb-3">
                              <div className="enKidsIcon mr-2">
                                <Image
                                  src={require("../../../../../assets/images/ActionImages/highchair.svg")}
                                  alt="View"
                                  title="View"
                                  className="custom"
                                />
                              </div>
                              <div className="pl-md-2 enPartyPersonEdit">
                                <div className="f14-500 pb-2">Highchair</div>
                                <div className="d-flex align-items-center">
                                  <Button
                                    variant="link"
                                    className="p-0"
                                    onClick={DecreaseHighchairItem}
                                  >
                                    <Image
                                      src={require("../../../../../assets/images/UserManagement/minus.svg")}
                                      alt="Remove"
                                      title="Remove"
                                      fluid
                                    />
                                  </Button>
                                  <input
                                    placeholder="00"
                                    className="enInputValueOnly f12-700"
                                    value={state.highchair}
                                    onChange={() => {}}
                                  />
                                  <Button
                                    variant="link"
                                    className="p-0"
                                    onClick={IncrementhighchairItem}
                                  >
                                    <Image
                                      src={require("../../../../../assets/images/UserManagement/plus.svg")}
                                      alt="Add"
                                      title="Add"
                                      fluid
                                    />
                                  </Button>
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                ) : null}
                <Row>
                  {state.onBoardingRoomNumber === true ? (
                    <Col>
                      <Form.Group>
                        <TextField
                          id="room_number"
                          label="Room No."
                          type="number"
                          variant="outlined"
                          className={`w-100 ${
                            formik.errors.room_number &&
                            formik.touched.room_number
                              ? "enError"
                              : ""
                          }`}
                          onInput={(e) => {
                            e.target.value = Math.max(
                              0,
                              parseInt(e.target.value)
                            )
                              .toString()
                              .slice(0, 6);
                          }}
                          name="room_number"
                          onChange={formik.handleChange}
                          value={formik.values.room_number}
                          onBlur={formik.handleBlur}
                          // isInvalid={
                          //   formik.errors.room_number &&
                          //   formik.touched.room_number
                          // }
                        />
                        {formik.errors.room_number &&
                        formik.touched.room_number ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.room_number}
                          </div>
                        ) : null}
                      </Form.Group>
                    </Col>
                  ) : null}
                  {totalAdultKids <= state.autoAcceptPaxLimit ? (
                    <Col>
                      <Form.Group>
                        <TextField
                          id="table_number"
                          label="Table No."
                          type="number"
                          variant="outlined"
                          className={`w-100 ${
                            formik.errors.table_number &&
                            formik.touched.table_number
                              ? "enError"
                              : ""
                          }`}
                          onInput={(e) => {
                            e.target.value = Math.max(
                              0,
                              parseInt(e.target.value)
                            )
                              .toString()
                              .slice(0, 6);
                          }}
                          name="table_number"
                          onChange={formik.handleChange}
                          value={formik.values.table_number}
                          onBlur={formik.handleBlur}
                          // isInvalid={
                          //   formik.errors.table_number &&
                          //   formik.touched.table_number
                          // }
                        />
                        {formik.errors.table_number &&
                        formik.touched.table_number ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.table_number}
                          </div>
                        ) : null}
                      </Form.Group>
                    </Col>
                  ) : null}
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="f16-500 pb-1 pt-3">Seating Preference</div>
                    <div className="f12-400 pb-3">
                      Seating is a subject to availability. Your Preference will
                      be considered.
                    </div>
                  </Col>
                </Row>
                <Form.Row>
                  {allSeatingArea &&
                    allSeatingArea.map((item, index) => (
                      <div className="col-6 col-sm-6 col-md-4" key={index}>
                        <ReusableOnboardingMapButton
                          key={index}
                          classsection={
                            formik.values.seating_preference === item.title
                              ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle"
                              : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                          }
                          src={item.icon}
                          title={item.title}
                          onClick={() => onButtonClick(item.title)}
                        />
                      </div>
                    ))}
                </Form.Row>
              </Col>
              <Col md={12}>
                <div className="f16-500 pt-3 pb-2">Special Occasion</div>
                <Form.Group>
                  <TextField
                    id="occasion"
                    label="Occasion"
                    placeholder=""
                    type="text"
                    variant="outlined"
                    multiline
                    rows={4}
                    className={`w-100 ${
                      formik.errors.occasion && formik.touched.occasion
                        ? "enError"
                        : ""
                    }`}
                    inputProps={{
                      maxLength: 512,
                    }}
                    name="occasion"
                    onChange={formik.handleChange}
                    value={formik.values.occasion}
                    onBlur={formik.handleBlur}
                    // isInvalid={
                    //   formik.errors.occasion && formik.touched.occasion
                    // }
                  />
                  {formik.errors.occasion && formik.touched.occasion ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.occasion}
                    </div>
                  ) : null}
                </Form.Group>
                <Media query="(min-width: 992px)">
                  <div className="d-flex align-items-center pt-4">
                    <Button
                      variant="outline-secondary"
                      className="btn150px btn-md mr-4 px-5"
                      onClick={() =>
                        history.push(
                          `/offline-events-details/${props?.getSingleEventInfo?._id}`
                        )
                      }
                    >
                      Cancel
                    </Button>
                    {props.getSingleEventInfo?.booking_closed ? null : (
                      <Button
                        variant="danger"
                        className="btn150px btn-md px-5"
                        onClick={() => adultError()}
                      >
                        {props?.editAction ? "Update" : "Save"}
                      </Button>
                    )}
                  </div>
                </Media>
                <Media query="(max-width: 991px)">
                  <div className="d-flex justify-content-center py-2 border-top fixed-bottom bg-white">
                    <Button
                      variant="outline-secondary"
                      className="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                      onClick={() =>
                        history.push(
                          `/offline-events-details/${props?.getSingleEventInfo?._id}`
                        )
                      }
                    >
                      Cancel
                    </Button>
                    {props.getSingleEventInfo?.booking_closed ? null : (
                      <div className="ml-2">
                        <Button
                          variant="danger"
                          className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                          onClick={() => adultError()}
                        >
                          {props?.editAction ? "Update" : "Save"}
                        </Button>
                      </div>
                    )}
                  </div>
                </Media>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </React.Fragment>
  );
};

AddRsvpEvent.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  add_rsvp_events: PropTypes.func.isRequired,
  rsvp_edit_perticular_event_request: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  eventSessionSettings:
    state?.onboarding?.restaurantDetails?.eventSessionSettings,
  eventAutoAcceptSetting:
    state?.onboarding?.restaurantDetails?.eventAutoAcceptSetting,
  allSeatingAreas: state.category.seating_area,
  subscriptionDetails: state.onboarding.onboard_subscription_details,
  getSingleEventInfo: state.rsvpEvent?.get_single_event_info,
  subscriptionData:
    state.onboarding?.onboard_subscription_details?.casual_dining_status
      ?.event_management.offline_event,
  seatingArea:
    state.onboarding?.onboard_subscription_details?.casual_dining_status
      ?.seating?.general_seating?.seating_areas,
  //   allDinnerDetails: state.allDinerDetails.vendor_all_diner.data,
  //   dinerDetailsInfo: state.allDinerDetails.diner_Details,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  add_rsvp_events,
  rsvp_edit_perticular_event_request,
  //   get_diner_reservation,
  //   get_pending_diner,
  //   get_reservation_diner,
})(withRouter(AddRsvpEvent));

// (Seat Selection Not Available at this time, will be assigned at The Event)
